import { render, staticRenderFns } from "./Quality.vue?vue&type=template&id=68bfc47e&scoped=true&"
import script from "./Quality.vue?vue&type=script&lang=js&"
export * from "./Quality.vue?vue&type=script&lang=js&"
import style0 from "./Quality.vue?vue&type=style&index=0&id=68bfc47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfc47e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
